import moment from 'moment';
import getTimezone from "./getTimezone";
import formatTimezone from "./formatTimezone";

function formatDateTime(date, showTimezone = true) {
  const m = moment.tz(date, getTimezone());
  const formattedDate = m.format('MMM DD, YYYY');
  const formattedTime = m.format('HH:mm');

  if (showTimezone) {
    const formattedTimezone = formatTimezone(m);
    const format = `${formattedDate} at ${formattedTime} ${formattedTimezone}`;
    return format;
  } else {
    return `${formattedDate}, ${formattedTime}`;
  }
}

export default formatDateTime;